<template>
  <div class="redirect" v-title data-title="城市合伙人">
    <img src="../../assets/images/redirect-img/0.gif" alt="">
    <img src="../../assets/images/redirect-img/1.gif" alt="">
    <img src="../../assets/images/redirect-img/2.gif" alt="">
    <img src="../../assets/images/redirect-img/3.png" alt="">
    <!-- 获取资料 -->
    <div class="get-data">
      <!-- 标题 -->
      <div class="content">
        <p class="title">
          免费获取资料
        </p>
        <!-- 姓名 -->
        <div class="name">
          <p class="name-title">
            姓名<span>*</span>
          </p>
          <input type="text" placeholder="请输入姓名" v-model="name">
        </div>
        <!-- 手机号 -->
        <div class="phone">
          <p class="phone-title">
            请输入电话<span>*</span>          
          </p>
          <input type="text" placeholder="请输入手机号" class="phone-input" v-model="phone">
          <div class="verification-code">
            <input type="text" placeholder="请输入验证码" class="verification-code-input" v-model="verification_code">
            <van-button slot="button" size="small" type="primary" :disabled="isbtn" color="#4473c5" @click="btns">{{btnTitle}}</van-button>
          </div>
        </div>
        <!-- 获取按钮 -->
        <div class="btn" @click="get_btn">
          立即获取
        </div>
      </div>
    </div>
    <!-- <img src="../../assets/images/redirect-img/8.png" alt=""> -->
    <img src="../../assets/images/redirect-img/4.png" alt="">
    <!-- 获取资料 -->
    <div class="get-data">
      <!-- 标题 -->
      <div class="content">
        <p class="title">
          免费获取资料
        </p>
        <!-- 姓名 -->
        <div class="name">
          <p class="name-title">
            姓名<span>*</span>
          </p>
          <input type="text" placeholder="请输入姓名" v-model="name">
        </div>
        <!-- 手机号 -->
        <div class="phone">
          <p class="phone-title">
            请输入电话<span>*</span>          
          </p>
          <input type="text" placeholder="请输入手机号" class="phone-input" v-model="phone">
          <div class="verification-code">
            <input type="text" placeholder="请输入验证码" class="verification-code-input" v-model="verification_code">
            <van-button slot="button" size="small" type="primary" :disabled="isbtn" color="#4473c5" @click="btns">{{btnTitle}}</van-button>
          </div>
        </div>
        <!-- 获取按钮 -->
        <div class="btn" @click="get_btn">
          立即获取
        </div>
      </div>
    </div>
    <img src="../../assets/images/redirect-img/5.gif" alt="">
    <img src="../../assets/images/redirect-img/6.png" alt="">
    <!-- 获取资料 -->
    <div class="get-data">
      <!-- 标题 -->
      <div class="content">
        <p class="title">
          免费获取资料
        </p>
        <!-- 姓名 -->
        <div class="name">
          <p class="name-title">
            姓名<span>*</span>
          </p>
          <input type="text" placeholder="请输入姓名" v-model="name">
        </div>
        <!-- 手机号 -->
        <div class="phone">
          <p class="phone-title">
            请输入电话<span>*</span>          
          </p>
          <input type="text" placeholder="请输入手机号" class="phone-input" v-model="phone">
          <div class="verification-code">
            <input type="text" placeholder="请输入验证码" class="verification-code-input" v-model="verification_code">
            <van-button slot="button" size="small" type="primary" :disabled="isbtn" color="#4473c5" @click="btns">{{btnTitle}}</van-button>
          </div>
        </div>
        <!-- 获取按钮 -->
        <div class="btn" @click="get_btn">
          立即获取
        </div>
      </div>
    </div>
    <img src="../../assets/images/redirect-img/8.png" alt="">
    <img src="../../assets/images/redirect-img/7.gif" alt="">
  </div>
</template>
<script>

import Vue from 'vue';
import { Button, Toast} from 'vant';
Vue.use(Button);
Vue.use(Toast);

export default {
  data(){
    return{
      name : '',
      phone : '',
      verification_code : '',
      btnTitle : "获取验证码",
      isbtn : false,
      input_verification_code : '', // 验证码
    }
  },
  methods:{
    // 验证码
    btns(){
      if ( !this.name) {
        Toast('姓名不能为空');
        // return false
      } else if(!this.phone){
        Toast('手机号码不能为空');
      } else if (!/^1[345678]\d{9}$/.test(this.phone)) {
        // this.errors = {
        //   phone:"请输入正确是手机号"
        // }
        Toast('请输入正确的手机号');
      } else{
        this.$axios.post("http://members.kfm666666.net/api/register/verification_code/send?username=" + this.phone).then((res => {
          // console.log(res.data.data)
          this.input_verification_code = res.data.data
          Toast(res.data.msg)
        }))
        //倒计时
        let time = 60;
        let timer = setInterval(() => {
          if(time == 0) {
            clearInterval(timer);
            this.btnTitle = "获取验证码";
            this.isbtn = false;
          } else {
            this.isbtn = true;
            this.btnTitle = time + '秒后重试';
            time--
          }
        },1000)
      }
    },
    // 获取
    get_btn(){
      if (!this.name) {
        // this.errors = {
        //   phone:"手机号码不能为空"
        // }
        // return false
        Toast('姓名不能为空');
      } else if(!this.phone){
        Toast('手机号码不能为空');
      } else if (!/^1[345678]\d{9}$/.test(this.phone)) {
        // this.errors = {
        //   phone:"请输入正确是手机号"
        // }
        Toast('请输入正确的手机号');
      } else if(this.input_verification_code != this.verification_code){
        Toast('验证码错误');
      }else{
        this.$axios.post('http://members.kfm666666.net/api/register/add/wx_h/',{
          mobile : this.phone,
          pass : this.verification_code,
          username : this.name
        }).then((res) => {
          // console.log(res)
          Toast(res.data.msg);
          // if (res.data.code == 1) {
          //   Toast('获取成功');
          //   this.$router.go(0)
          // } else if (res.data.code == 0){
          //   Toast(res.data.msg);
          // }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
  *{
    margin: 0;
    padding: 0;
  }
  .redirect{
    width: 7.5rem;
    display: flex;
    flex-direction: column;
    img{
      width: 7.5rem;
    }
    // 免费获取资料
    .get-data{
      width: 100%;
      height: 5.5rem;
      background: #4f7fed;
      border-top: .2rem solid #4f7fed;
      .content{
        width: 6.67rem;
        height: 6rem;
        margin: 0 auto;
        background: #ffffff;
        overflow: hidden;
        padding: 0 .23rem;
        // 大标题
        .title{
          width: 6.35rem;
          height: .8rem;
          margin: 0 auto;
          margin-top: .24rem;
          background: #4473c5;
          text-align: center;
          line-height: .8rem;
          font-size: .5rem;
          color: #fff;
        }
        // 姓名
        .name{
          margin-left: .25rem;
          .name-title{
            color: #343434;
            font-size: .3rem;
            line-height: .7rem;
            span{
              color: #fa0c10;
            }
          }
          input{
            width: 5.59rem;
            height: .58rem;
            border-radius: .1rem;
            border: .01rem solid #cbcbcb;
            outline: none;
            padding-left: .1rem;
          }
        }
        // 手机号
        .phone{
          margin-left: .25rem;
          .phone-title{
            color: #343434;
            font-size: .3rem;
            line-height: .7rem;
            span{
              color: #fa0c10;
            }
          }
          input{
            width: 5.59rem;
            height: .58rem;
            border-radius: .1rem;
            border: .01rem solid #cbcbcb;
            outline: none;
            padding-left: .1rem;
          }
          .verification-code{
            display: flex;
            align-items: center;
            margin-top: .2rem;
            .verification-code-input{
              width: 4.3rem;
              margin-right: .2rem;
            }
          }
        }
        .btn{
          width: 4.8rem;
          height: .6rem;
          background: #4872c4;
          text-align: center;
          line-height: .6rem;
          font-size: .3rem;
          color: #fff;
          margin: 0 auto;
          border-radius: .3rem;
          margin-top: .3rem;
        }
      }
    }
  }
</style>